import { render, staticRenderFns } from "./playerTable.vue?vue&type=template&id=bc11dad6&scoped=true"
import script from "./playerTable.vue?vue&type=script&lang=js"
export * from "./playerTable.vue?vue&type=script&lang=js"
import style0 from "./playerTable.vue?vue&type=style&index=0&id=bc11dad6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc11dad6",
  null
  
)

export default component.exports